import CreateAuditorStore from './auditor.create';
import ListAuditorStore from './auditor.list';
import AuditorDetailsStore from './auditor.details';

export const auditorStores = {
  create: CreateAuditorStore,
  list: ListAuditorStore,
  details: AuditorDetailsStore
};
